import { c as _c } from "react/compiler-runtime";
import { FrontWeightLevel, frontWeightLevelToNumber } from '@/lib/piano/touch-design/front-weight-level';
import type { KeyboardLike, KeyWith } from '@/lib/piano/keyboard';
import { useMemo } from 'react';
import { useDefaultSerie } from './use-default-serie';
import { useFrontWeightCurve } from '@/hooks/standard-curves/use-front-weight-curve';
export const useFrontWeightStandardSeries = (keyboard, levels) => {
  const $ = _c(6);
  const {
    getFrontWeightCurve
  } = useFrontWeightCurve(keyboard);
  let t0;
  if ($[0] !== getFrontWeightCurve || $[1] !== levels) {
    let t1;
    if ($[3] !== getFrontWeightCurve) {
      t1 = level => [level, getFrontWeightCurve(frontWeightLevelToNumber(level))];
      $[3] = getFrontWeightCurve;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    const entries = levels.map(t1);
    t0 = Object.fromEntries(entries);
    $[0] = getFrontWeightCurve;
    $[1] = levels;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const frontWeightLevelSmoothedSeries = t0 as Record<FrontWeightLevel, number[]>;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [FrontWeightLevel.Level5, FrontWeightLevel.Level7, FrontWeightLevel.Level9];
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const seriesWithBoldVariant = t1;
  const defaultSeries = useDefaultSerie(keyboard, levels, seriesWithBoldVariant, frontWeightLevelSmoothedSeries);
  return defaultSeries;
};